import './Why.css'

const Why = () => {
    return (
        <>
            {/* why */}
            <div className="why">
                <div className="container">
                    <div className="text">
                        <h2>why should people choose <br /> <span>D. sherif abdelbaeth.</span></h2>
                        <div className="pro wow slideInLeft" data-wow-duration="1s" data-wow-delay="0.3s">
                            <i className="fa-regular fa-circle-check" />
                            <p>Ifbb pro Elite</p>
                        </div>
                        <div className="pro wow slideInLeft" data-wow-duration="1.5s" data-wow-delay="0.3s">
                            <i className="fa-regular fa-circle-check" />
                            <p>world champ</p>
                        </div>
                        <div className="pro wow slideInLeft" data-wow-duration="2s" data-wow-delay="0.3s">
                            <i className="fa-regular fa-circle-check" />
                            <p>Arab champ</p>
                        </div>
                        <div className="pro wow slideInLeft" data-wow-duration="2.5s" data-wow-delay="0.3s">
                            <i className="fa-regular fa-circle-check" />
                            <p>Diamond cup champ</p>
                        </div>
                        <div className="pro wow slideInLeft" data-wow-duration="3s" data-wow-delay="0.3s">
                            <i className="fa-regular fa-circle-check" />
                            <p>Over All junior 1st open, 2nd Over All Muscletech</p>
                        </div>
                        <div className="pro wow slideInLeft" data-wow-duration="3s" data-wow-delay="0.3s">
                            <i className="fa-regular fa-circle-check" />
                            <p>nassam certificate</p>
                        </div>
                    </div>
                    <div className="image">
                        <img src="images/IMG_4743.JPG" alt="photo" className="shadow-5" />
                    </div>
                </div>
            </div>
            {/* why */}
        </>
    );
}

export default Why;
